import { render, staticRenderFns } from "./MemberLawyerPage.vue?vue&type=template&id=3ec49f72&"
import script from "./MemberLawyerPage.vue?vue&type=script&lang=js&"
export * from "./MemberLawyerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports